import { Injectable, EventEmitter } from '@angular/core';

/**
 * This is for the user panel in the navigation bar.
 */
@Injectable()
export class CreateEventService {
  public create: EventEmitter<string> = new EventEmitter<string>();
  public destory: EventEmitter<string> = new EventEmitter<string>();

  createComponent(userMenuCom: string) {
    this.create.emit(userMenuCom);
  }

  destoryComponent(userMenuCom: string) {
    this.destory.emit(userMenuCom);
  }

  // test(){
  //     console.log('this. is for test');
  // }
}
